export const devMode = false; ///Note: mode must be change along with index.html (account)


// WEBPACK FOOTER //
// ./src/model/base.js